import React from "react";
import { Box, Button } from "@mui/material";

type Props = {
  onBack: () => void;
  onSave: () => void;
  onNext: () => void;
  disableNext?: boolean;
};

export default function ActionBar({ onBack, onSave, onNext, disableNext }: Props) {
  return (
    <Box 
      sx={{ 
        position: "sticky", 
        bottom: 0, 
        left: 0, 
        right: 0, 
        py: 2, 
        px: 3,
        display: "flex", 
        alignItems: "center",
        justifyContent: "space-between", 
        background: "#fff", 
        borderTop: "1px solid #e2e8f0",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.04)"
      }}
    >
      <Button 
        variant="text" 
        onClick={onBack}
        sx={{
          color: "#64748b",
          textTransform: "none",
          fontSize: "0.9rem",
          "&:hover": {
            backgroundColor: "rgba(100, 116, 139, 0.08)"
          }
        }}
      >
        Back
      </Button>
      
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Button 
          variant="outlined" 
          onClick={onSave}
          sx={{
            textTransform: "none",
            fontSize: "0.9rem",
            borderColor: "#e2e8f0",
            color: "#475569",
            "&:hover": {
              borderColor: "#cbd5e1",
              backgroundColor: "#f8fafc"
            }
          }}
        >
          Save
        </Button>
        <Button 
          variant="contained" 
          onClick={onNext} 
          disabled={disableNext}
          sx={{
            textTransform: "none",
            fontSize: "0.9rem",
            backgroundColor: "#712d94",
            boxShadow: "0 1px 3px rgba(113, 45, 148, 0.3)",
            "&:hover": {
              backgroundColor: "#5a2470",
              boxShadow: "0 2px 6px rgba(113, 45, 148, 0.4)"
            },
            "&:disabled": {
              backgroundColor: "#cbd5e1",
              color: "#94a3b8"
            }
          }}
        >
          Save & Continue
        </Button>
      </Box>
    </Box>
  );
}


